/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudArrowUploadIcon16Solid = forwardRef('NetCloudArrowUploadIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.142 3.155a4.252 4.252 0 0 1 7.724-1.139A4.5 4.5 0 1 1 11.25 11H8.875V6.362l1.506 1.507A.875.875 0 1 0 11.62 6.63L9.326 4.338a1.875 1.875 0 0 0-2.652 0L4.381 6.631A.875.875 0 1 0 5.62 7.87l1.506-1.507V11H4.25a4 4 0 0 1-1.108-7.845Z" }),
        React.createElement("path", { d: "M7.125 11h1.75v3.25a.875.875 0 0 1-1.75 0V11Z" })));
});
